import React, { Component } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import TooltipText from '../../../../../components/Tooltip';
export default class TextCalendar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            date: moment(),
            title: this.props.heading,
            key: this.props.inputKey,
            options: this.props.optionConfig,
            dateRange: [{
                startDate: new Date(),
                endDate: moment().add(7, 'days'),
                key: 'selection'
            }]
        }

    }

    saveHandler = (e) => {
        e.preventDefault();
        // this.props.onClickHandler(this.state.key, this.state.date);
        // this.setState({
        //     editMode: false
        // })
        // this.props.editDeactive();
        this.props.onSave()
    }


    resetForm = (e) => {
        e.preventDefault();
        this.setState({ editMode: false })
        this.props.editDeactive();
    }

    dateChangeHandler = (event) => {
        console.log(event.target.value, '')
        this.setState({ date: event })
        // return event;÷
    }

    getEditButton = () => {
        if (this.props.isEditable) {
            return <button onClick={() => { this.setState({ editMode: true, date: this.props.dateValue }); this.props.onEditClick() }}
                className={`ml-8 border-0 bg-tr pr-hover ${this.props.editActive ? 'd-none' : ''} ${this.props.enableEditing ? 'enableEditButton' : ''}`}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                    <rect x="0.5" y="0.5" width="27" height="27" rx="3.5" fill="white" stroke="#E2E2EA" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M18.3957 10.6971L19.2318 9.86101L17.389 8.01821L16.5529 8.85428L18.3957 10.6971ZM17.3406 11.7522L15.4978 9.90936L8.60424 16.803L8.1801 19.0699L10.447 18.6458L17.3406 11.7522ZM20.3314 8.85049C20.8895 9.40859 20.8895 10.3134 20.3314 10.8715L11.3388 19.8642C11.2324 19.9705 11.0964 20.0423 10.9485 20.0699L7.38362 20.7369C6.86812 20.8334 6.41664 20.3819 6.51308 19.8664L7.18006 16.3015C7.20772 16.1536 7.27946 16.0176 7.38584 15.9112L16.3785 6.91857C16.9366 6.36048 17.8414 6.36048 18.3995 6.91857L20.3314 8.85049ZM20.0074 20.75H13.9926C13.0025 20.75 13.0025 19.25 13.9926 19.25H20.0074C20.9975 19.25 20.9975 20.75 20.0074 20.75Z" fill="#414346" />
                </svg>
            </button>
        }
    }

    getCurrentYear = () => {
        const year = new Date().getFullYear();
        return `${year}-12-31`
    }

    render() {
        return <>
            {!this.props.editActive && <div className='main-box'>
                <div className="name-box">
                    <div className="row">
                        <div className="col-md-10 col-10">
                            <h3 className="fz16 mb-6">{this.state.title}</h3>
                            <h4 className={`fz16 mb-6`}>
                                {this.props.value ? this.state.title === 'Birthday' ? moment(this.props.value).format('Do MMM YYYY') : moment(this.props.value).format('Do MMMM YYYY') : '-'}
                            </h4>
                        </div>
                        <div className="col-md-2 col-2 pl-0 d-flex align-items-center justify-content-center">
                            {(this.props.userProfile?.allowed_modules?.includes('lead_sharing') && this.props.leadAccess === 'view') ?
                                <TooltipText title={"You don't have permission"}>
                                    <button
                                        className={`border-0 bg-tr pr-hover ${this.props.editActive ? 'd-none' : ''} ${(this.props.userProfile?.allowed_modules?.includes('lead_sharing') && this.props.leadAccess === 'view') ? 'cursor-not-allowed' : ''}`}
                                        disabled={(this.props.userProfile?.allowed_modules?.includes('lead_sharing') && this.props.leadAccess === 'view')}
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                                            <rect x="0.5" y="0.5" width="27" height="27" rx="3.5" fill="white" stroke="#E2E2EA" />
                                            <path fillRule="evenodd" clipRule="evenodd" d="M18.3957 10.6971L19.2318 9.86101L17.389 8.01821L16.5529 8.85428L18.3957 10.6971ZM17.3406 11.7522L15.4978 9.90936L8.60424 16.803L8.1801 19.0699L10.447 18.6458L17.3406 11.7522ZM20.3314 8.85049C20.8895 9.40859 20.8895 10.3134 20.3314 10.8715L11.3388 19.8642C11.2324 19.9705 11.0964 20.0423 10.9485 20.0699L7.38362 20.7369C6.86812 20.8334 6.41664 20.3819 6.51308 19.8664L7.18006 16.3015C7.20772 16.1536 7.27946 16.0176 7.38584 15.9112L16.3785 6.91857C16.9366 6.36048 17.8414 6.36048 18.3995 6.91857L20.3314 8.85049ZM20.0074 20.75H13.9926C13.0025 20.75 13.0025 19.25 13.9926 19.25H20.0074C20.9975 19.25 20.9975 20.75 20.0074 20.75Z" fill="#414346" />
                                        </svg>
                                    </button>
                                </TooltipText> :
                                this.getEditButton()}
                        </div>
                    </div>
                </div>

            </div>
            }

            {/* edit input */}
            {this.props.editActive && <div className={`edit-input-modal active`}>
                <form className='form-group mb-0'>
                    <div className="row ">
                        <div className="col-8 pr-0">
                            <h3 className="fz16 mb-6">{this.props.heading}</h3>
                        </div>
                        <div className="col-4 d-flex align-itmes-center justify-content-end">
                            <button onClick={(e) => this.saveHandler(e)} className='border-0 ml4 bg-tr px-2'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <rect width="20" height="20" rx="4" fill="#0062FF" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M5.58613 9.97668C5.25907 9.65288 4.73144 9.65552 4.40764 9.98259C4.08383 10.3097 4.08648 10.8373 4.41354 11.1611L7.60133 14.3005C7.94405 14.6398 8.50236 14.6182 8.81787 14.2535L15.6301 6.37854C15.9312 6.03047 15.8931 5.5042 15.545 5.2031C15.197 4.902 14.6707 4.94008 14.3696 5.28815L8.14051 12.489L5.58613 9.97668Z" fill="white" />
                            </svg></button>
                            <button onClick={(e) => this.resetForm(e)} className='border-0 ml4 bg-tr pr-0'><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M0 4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V16C20 18.2091 18.2091 20 16 20H4C1.79086 20 0 18.2091 0 16V4Z" fill="#B5B5BE" />
                                <path fillRule="evenodd" clipRule="evenodd" d="M11.1761 10.0006L15.5737 14.4021C15.899 14.7277 15.8987 15.2553 15.5731 15.5806C15.2476 15.9059 14.7199 15.9057 14.3946 15.5801L9.99674 11.1782L5.58865 15.5798C5.26298 15.905 4.73534 15.9046 4.41014 15.5789C4.08495 15.2532 4.08534 14.7256 4.41102 14.4004L8.81876 9.99919L4.41288 5.58931C4.08759 5.26373 4.08783 4.73609 4.41341 4.4108C4.739 4.08551 5.26663 4.08575 5.59192 4.41134L9.99815 8.82155L14.3948 4.43145C14.7205 4.10625 15.2481 4.10664 15.5733 4.43232C15.8985 4.758 15.8981 5.28564 15.5724 5.61083L11.1761 10.0006Z" fill="white" />
                            </svg></button>
                        </div>
                    </div>
                    <div className='form-group'>
                        <DatePicker
                            selected={this.props.value ? new Date(this.props.value) : ''}
                            placeholderText={'Select Date'}
                            onChange={(date) => this.props.onValueChange(date)}
                            dateFormat="dd MMM yyyy"
                            className={`form-control text-input`}
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            maxDate={new Date()}
                        />
                    </div>
                </form>
            </div>}
        </>
    }
}

// TextDropdown.propTypes = {
//     inputKey: PropTypes.string,
//     heading: PropTypes.string,
//     placeholder: PropTypes.string,
//     isEditable: PropTypes.bool,
//     enableEditing: PropTypes.bool,
//     defaultValue: PropTypes.number,
//     defaultLable: PropTypes.string,
//     optionConfig: PropTypes.any,
//     onClickHandler: PropTypes.func,
// }